import * as React from "react"
import Icon from "@ant-design/icons"

const EditPenSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M3,17.25 L3,21 L6.75,21 L17.81,9.94 L14.06,6.19 L3,17.25 L3,17.25 Z M20.71,7.04 C21.1,6.65 21.1,6.02 20.71,5.63 L18.37,3.29 C17.98,2.9 17.35,2.9 16.96,3.29 L15.13,5.12 L18.88,8.87 L20.71,7.04 L20.71,7.04 Z"
      id="Shape"
    ></path>
  </svg>
)

export const EditPenIcon = props => <Icon component={EditPenSvg} {...props} />

const ArrowRight = () => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="right"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
  </svg>
)

export const ArrowRightIcon = props => (
  <Icon component={ArrowRight} {...props} />
)

const SendSvg = () => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="right"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
    <polygon id="Shape" points="2.01 21 23 12 2.01 3 2 10 17 12 2 14"></polygon>
  </svg>
)

export const SendIcon = props => <Icon component={SendSvg} {...props} />

const MailSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 L20,4 Z M20,8 L12,13 L4,8 L4,6 L12,11 L20,6 L20,8 L20,8 Z"
      id="Shape"
    ></path>
  </svg>
)

export const MailIcon = props => <Icon component={MailSvg} {...props} />

const PhoneSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M6.62,10.79 C8.06,13.62 10.38,15.93 13.21,17.38 L15.41,15.18 C15.68,14.91 16.08,14.82 16.43,14.94 C17.55,15.31 18.76,15.51 20,15.51 C20.55,15.51 21,15.96 21,16.51 L21,20 C21,20.55 20.55,21 20,21 C10.61,21 3,13.39 3,4 C3,3.45 3.45,3 4,3 L7.5,3 C8.05,3 8.5,3.45 8.5,4 C8.5,5.25 8.7,6.45 9.07,7.57 C9.18,7.92 9.1,8.31 8.82,8.59 L6.62,10.79 L6.62,10.79 Z"
      id="Shape"
    ></path>
  </svg>
)

export const PhoneIcon = props => <Icon component={PhoneSvg} {...props} />

const LocationSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M12,2 C8.13,2 5,5.13 5,9 C5,14.25 12,22 12,22 C12,22 19,14.25 19,9 C19,5.13 15.87,2 12,2 L12,2 Z M12,11.5 C10.62,11.5 9.5,10.38 9.5,9 C9.5,7.62 10.62,6.5 12,6.5 C13.38,6.5 14.5,7.62 14.5,9 C14.5,10.38 13.38,11.5 12,11.5 L12,11.5 Z"
      id="Shape"
    ></path>
  </svg>
)

export const LocationIcon = props => <Icon component={LocationSvg} {...props} />

const InformationSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
    <path
      d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M13,17 L11,17 L11,11 L13,11 L13,17 L13,17 Z M13,9 L11,9 L11,7 L13,7 L13,9 L13,9 Z"
      id="Shape"
    ></path>
  </svg>
)

export const InformationIcon = props => (
  <Icon component={InformationSvg} {...props} />
)

const HomeSvg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
    <polygon
      id="Shape"
      points="10 20 10 14 14 14 14 20 19 20 19 12 22 12 12 3 2 12 5 12 5 20"
    ></polygon>
  </svg>
)

export const HomeIcon = props => <Icon component={HomeSvg} {...props} />

const KeyCircleSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 30 30" fill="currentColor">
    <g strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="ROOMS-&amp;-RATES-With-Footnote"
        transform="translate(-51.000000, -366.000000)"
      >
        <g id="Group-19" transform="translate(1.000000, 345.000000)">
          <g id="Group-6" transform="translate(50.000000, 21.000000)">
            <circle
              id="Oval"
              fill="currentColor"
              cx="15"
              cy="15"
              r="15"
            ></circle>
            <g id="Group" transform="translate(6.000000, 6.000000)">
              <polygon id="Shape" points="0 0 18 0 18 18 0 18"></polygon>
              <path
                d="M9.4875,7.5 C8.8725,5.7525 7.2075,4.5 5.25,4.5 C2.7675,4.5 0.75,6.5175 0.75,9 C0.75,11.4825 2.7675,13.5 5.25,13.5 C7.2075,13.5 8.8725,12.2475 9.4875,10.5 L12.75,10.5 L12.75,13.5 L15.75,13.5 L15.75,10.5 L17.25,10.5 L17.25,7.5 L9.4875,7.5 L9.4875,7.5 Z M5.25,10.5 C4.425,10.5 3.75,9.825 3.75,9 C3.75,8.175 4.425,7.5 5.25,7.5 C6.075,7.5 6.75,8.175 6.75,9 C6.75,9.825 6.075,10.5 5.25,10.5 L5.25,10.5 Z"
                id="Shape"
                fill="#E8EDF2"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const KeyCircleIcon = props => (
  <Icon component={KeyCircleSvg} {...props} />
)

const SquarePlusCircleSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 30 30" fill="currentColor">
    <g stroke="none" strokeWidth="1" fill="none">
      <g
        id="ROOMS-&amp;-RATES-With-Footnote"
        transform="translate(-296.000000, -366.000000)"
      >
        <g id="Group-19" transform="translate(1.000000, 345.000000)">
          <g id="Group-6-Copy" transform="translate(295.000000, 21.000000)">
            <circle
              id="Oval"
              fill="currentColor"
              cx="15"
              cy="15"
              r="15"
            ></circle>
            <g id="Group" transform="translate(6.000000, 6.000000)">
              <polygon id="Shape" points="0 0 18 0 18 18 0 18"></polygon>
              <path
                d="M14.25,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,3.75 C15.75,2.925 15.075,2.25 14.25,2.25 L14.25,2.25 Z M12.75,9.75 L9.75,9.75 L9.75,12.75 L8.25,12.75 L8.25,9.75 L5.25,9.75 L5.25,8.25 L8.25,8.25 L8.25,5.25 L9.75,5.25 L9.75,8.25 L12.75,8.25 L12.75,9.75 L12.75,9.75 Z"
                id="Shape"
                fill="#E8EDF2"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SquarePlusCircleIcon = props => (
  <Icon component={SquarePlusCircleSvg} {...props} />
)

const WalletCircleSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 30 30" fill="currentColor">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="ROOMS-&amp;-RATES-With-Footnote"
        transform="translate(-504.000000, -366.000000)"
      >
        <g id="Group-19" transform="translate(1.000000, 345.000000)">
          <g id="Group-6-Copy-3" transform="translate(503.000000, 21.000000)">
            <circle
              id="Oval"
              fill="currentColor"
              cx="15"
              cy="15"
              r="15"
            ></circle>
            <g id="Group" transform="translate(6.000000, 6.000000)">
              <polygon id="Shape" points="0 0 18 0 18 18 0 18"></polygon>
              <path
                d="M15.75,13.5 L15.75,14.25 C15.75,15.075 15.075,15.75 14.25,15.75 L3.75,15.75 C2.9175,15.75 2.25,15.075 2.25,14.25 L2.25,3.75 C2.25,2.925 2.9175,2.25 3.75,2.25 L14.25,2.25 C15.075,2.25 15.75,2.925 15.75,3.75 L15.75,4.5 L9,4.5 C8.1675,4.5 7.5,5.175 7.5,6 L7.5,12 C7.5,12.825 8.1675,13.5 9,13.5 L15.75,13.5 L15.75,13.5 Z M9,12 L16.5,12 L16.5,6 L9,6 L9,12 L9,12 Z M12,10.125 C11.3775,10.125 10.875,9.6225 10.875,9 C10.875,8.3775 11.3775,7.875 12,7.875 C12.6225,7.875 13.125,8.3775 13.125,9 C13.125,9.6225 12.6225,10.125 12,10.125 L12,10.125 Z"
                id="Shape"
                fill="#E8EDF2"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const WalletCircleIcon = props => (
  <Icon component={WalletCircleSvg} {...props} />
)

const FbSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 8 16">
    <defs>
      <path
        d="M9.96428765,17 L9.96428765,8.99906325 L12.1728961,8.99906325 L12.4655844,6.24189614 L9.96428765,6.24189614 L9.96804007,4.86190746 C9.96804007,4.14279581 10.0363653,3.75747936 11.0692173,3.75747936 L12.4499494,3.75747936 L12.4499494,1 L10.2410282,1 C7.58775865,1 6.65387656,2.33752269 6.65387656,4.58681525 L6.65387656,6.24220839 L5,6.24220839 L5,8.9993755 L6.65387656,8.9993755 L6.65387656,17 L9.96428765,17 Z"
        id="path-1"
      ></path>
    </defs>
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Home-Page:-Full" transform="translate(-737.000000, -7481.000000)">
        <g id="Group-12" transform="translate(-1.000000, 7088.000000)">
          <g
            id="icons/social/facebook"
            transform="translate(733.000000, 392.000000)"
          >
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <use id="Mask" fill="#212B36" xlinkHref="#path-1"></use>
            <g id="Group" mask="url(#mask-2)" fill="currentColor">
              <g id="Color">
                <rect
                  id="color/background"
                  x="0"
                  y="0"
                  width="18"
                  height="18"
                  rx="4"
                ></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const FbIcon = props => <Icon component={FbSvg} {...props} />

const TwitterSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 14">
    <defs>
      <path
        d="M8.76891299,5.51733138 L8.80359563,6.08923193 L8.22555151,6.01920329 C6.12147091,5.75076017 4.28329061,4.84038787 2.72257148,3.31142925 L1.95955324,2.55278566 L1.76301824,3.11301478 C1.34682647,4.36185884 1.61272677,5.68073153 2.47979295,6.56776096 C2.94222825,7.05796143 2.83818031,7.12799007 2.04047942,6.83620407 C1.76301824,6.74283256 1.52023971,6.67280392 1.49711794,6.70781824 C1.41619177,6.78951832 1.69365295,7.85161934 1.91330971,8.27179117 C2.21389265,8.85536316 2.82661942,9.42726371 3.4971506,9.76573547 L4.06363384,10.0341786 L3.39310266,10.04585 C2.74569325,10.04585 2.72257148,10.0575215 2.79193678,10.3026217 C3.02315442,11.0612653 3.93646414,11.8665946 4.95382179,12.2167378 L5.6705965,12.4618381 L5.04630885,12.8353241 C4.12143825,13.3722104 3.03471531,13.6756678 1.94799236,13.6990107 C1.42775265,13.7106821 1,13.7573679 1,13.7923822 C1,13.9090966 2.41042766,14.5626972 3.23125031,14.8194689 C5.69371826,15.5781125 8.61862152,15.2513122 10.8151892,13.9557824 C12.3759083,13.0337386 13.9366274,11.2013226 14.664963,9.42726371 C15.058033,8.48187709 15.451103,6.754504 15.451103,5.92583177 C15.451103,5.38894554 15.4857857,5.3189169 16.1331951,4.67698771 C16.5147042,4.30350164 16.8730916,3.89500124 16.9424569,3.77828684 C17.0580657,3.55652949 17.0465048,3.55652949 16.4568998,3.75494396 C15.4742248,4.10508716 15.3354942,4.0584014 15.8210513,3.53318661 C16.1794386,3.15970053 16.6071913,2.48275703 16.6071913,2.28434255 C16.6071913,2.24932823 16.433778,2.30768543 16.237243,2.41272839 C16.0291471,2.52944278 15.5667119,2.70451438 15.2198854,2.80955734 L14.5955977,3.00797182 L14.0291145,2.6228143 C13.7169707,2.41272839 13.2776571,2.17929959 13.0464395,2.10927095 C12.4568345,1.94587079 11.5550857,1.96921367 11.0232851,2.15595671 C9.57817476,2.6811715 8.66486505,4.03505852 8.76891299,5.51733138 Z"
        id="path-twt-1"
      ></path>
    </defs>
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Home-Page:-Full" transform="translate(-771.000000, -8105.000000)">
        <g id="Group-12" transform="translate(-1.000000, 7711.000000)">
          <g id="Group-6" transform="translate(733.000000, 392.000000)">
            <g
              id="icons/social/twitter"
              transform="translate(38.000000, 0.000000)"
            >
              <mask id="mask-twt-2" fill="white">
                <use xlinkHref="#path-twt-1"></use>
              </mask>
              <use id="Mask" fill="#212B36" xlinkHref="#path-twt-1"></use>
              <g id="Group" mask="url(#mask-twt-2)" fill="currentColor">
                <g id="Color">
                  <rect
                    id="color/background"
                    x="0"
                    y="0"
                    width="18"
                    height="18"
                    rx="4"
                  ></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const TwitterIcon = props => <Icon component={TwitterSvg} {...props} />

const IgSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16">
    <defs>
      <path
        d="M8.12466486,1 L8.12466486,1.00243968 L9.78769954,1.00282453 C11.6831922,1.00497975 12.0288229,1.01698737 12.94343,1.05855221 C13.8949034,1.10205975 14.4113013,1.26104525 14.7552955,1.39461747 C15.2107015,1.57149392 15.5353816,1.78293244 15.8767329,2.12448697 C16.2182874,2.4660415 16.4297259,2.79133153 16.607009,3.24673757 C16.7405812,3.59032516 16.89977,4.10672308 16.9430742,5.05819642 C16.9829072,5.93452173 16.9961849,6.28859257 16.9992447,7.98414381 L16.9992447,10.0164661 C16.9961849,11.7120174 16.9829072,12.0660882 16.9430742,12.9424135 C16.8995667,13.8938868 16.7405812,14.4102848 16.607009,14.7538723 C16.4301325,15.2092784 16.2182874,15.5335519 15.8767329,15.8749031 C15.5351783,16.2164576 15.2109048,16.4278962 14.7552955,16.6047726 C14.4117079,16.7389548 13.8949034,16.8975336 12.94343,16.9410412 C12.0671047,16.9808742 11.7130339,16.9941518 10.0167286,16.9972117 L7.98340914,16.9972117 C6.28702189,16.9941518 5.93309859,16.9808742 5.05677328,16.9410412 C4.10529994,16.897127 3.58890202,16.7381415 3.24470451,16.6045693 C2.78929847,16.4276929 2.46400844,16.2162543 2.12245391,15.8746998 C1.78089938,15.5331453 1.56946086,15.2086685 1.39217779,14.7530591 C1.25860557,14.4094715 1.09941677,13.8930736 1.05611253,12.9416003 C1.01627956,12.065275 1.00359202,11.7112041 1.000707,10.0146475 L1.000707,7.98117959 C1.00359202,6.28497266 1.01627956,5.93208206 1.05611253,5.05575674 C1.09962007,4.10428341 1.25860557,3.58788549 1.39217779,3.24389128 C1.56905424,2.78848524 1.78089938,2.46319521 2.12245391,2.12164068 C2.46400844,1.78008615 2.78929847,1.56864763 3.24470451,1.39136457 C3.58869871,1.25718243 4.10529994,1.09860354 5.05677328,1.05489269 C5.24629752,1.04633243 5.41138446,1.03903368 5.57089419,1.03282571 L5.80833338,1.0243105 C6.32393788,1.00754092 6.8802379,1.00139104 8.12466486,1 Z M9,3.991 C6.23249342,3.99104182 3.98860214,6.2349331 3.98860214,9.00254133 C3.98860214,11.7701496 6.23249342,14.0130243 9.00010165,14.0130243 C11.7677099,14.0130243 14.0107879,11.7701496 14.0107879,9.00254133 C14.0107879,6.3077649 11.8840205,4.10950404 9.21727308,3.99567229 L9,3.991 Z M9.00010165,5.74964104 C10.7965158,5.74964104 12.2530019,7.20592384 12.2530019,9.00254133 C12.2530019,10.7989555 10.7965158,12.2554416 9.00010165,12.2554416 C7.20348416,12.2554416 5.74720136,10.7989555 5.74720136,9.00254133 C5.74720136,7.20592384 7.20348416,5.74964104 9.00010165,5.74964104 Z M14.2092149,2.62238402 C13.5627009,2.62279063 13.0381708,3.14671089 13.0381708,3.79342812 C13.0381708,4.43994206 13.5627009,4.96447223 14.2092149,4.96447223 C14.8557288,4.96447223 15.380259,4.43994206 15.380259,3.79342812 C15.380259,3.14691419 14.8557288,2.62238402 14.2092149,2.62238402 Z"
        id="path-ig-1"
      ></path>
    </defs>
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Home-Page:-Full" transform="translate(-809.000000, -7481.000000)">
        <g id="Group-12" transform="translate(-1.000000, 7088.000000)">
          <g id="Group-6" transform="translate(733.000000, 392.000000)">
            <g
              id="icons/social/instagram"
              transform="translate(76.000000, 0.000000)"
            >
              <mask id="mask-ig-2" fill="white">
                <use xlinkHref="#path-ig-1"></use>
              </mask>
              <use id="Mask" fill="#212B36" xlinkHref="#path-ig-1"></use>
              <g id="Group" mask="url(#mask-ig-2)" fill="currentColor">
                <g id="Color">
                  <rect
                    id="color/background"
                    x="0"
                    y="0"
                    width="18"
                    height="18"
                    rx="4"
                  ></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const IgIcon = props => <Icon component={IgSvg} {...props} />

const LinkedinSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16">
    <defs>
      <path
        d="M4.63220772,5.96723774 L4.63220772,16.2712145 L1.20278999,16.2712145 L1.20278999,5.96723774 L4.63220772,5.96723774 Z M13.0514509,5.7252804 C15.3081658,5.7252804 17,7.19829313 17,10.3632291 L17,10.3632291 L16.999863,16.2712145 L13.5705823,16.2712145 L13.5705823,10.7585811 C13.5705823,9.37392589 13.0743255,8.42907498 11.8328618,8.42907498 C10.8854127,8.42907498 10.3210799,9.06604236 10.0732254,9.68126231 C9.98254866,9.90174577 9.96029038,10.2089454 9.96029038,10.5168973 L9.96029038,10.5168973 L9.96029038,16.271488 L6.53046173,16.271488 L6.53046173,16.271488 L6.53092062,16.1744721 C6.53338861,15.646119 6.5451229,13.0490998 6.54917295,10.5968316 L6.54998874,10.0121998 C6.55009723,9.91560208 6.55019124,9.81951932 6.55026971,9.72409313 L6.55014496,8.359651 C6.54868694,7.16518582 6.54311813,6.23823542 6.53046173,5.96751129 L6.53046173,5.96751129 L9.96029038,5.96751129 L9.96029038,7.42698316 C10.4154549,6.72538896 11.2306556,5.7252804 13.0514509,5.7252804 Z M2.94016805,1 C4.11335026,1 4.83581955,1.76950366 4.85807783,2.77980205 C4.85807783,3.76917366 4.11335026,4.56083508 2.91756734,4.56083508 L2.91756734,4.56083508 L2.8956515,4.56083508 C1.74431665,4.56083508 1,3.76917366 1,2.77980205 C1,1.76950366 1.76698584,1 2.94016805,1 Z"
        id="path-linkedin-1"
      ></path>
    </defs>
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Home-Page:-Full" transform="translate(-847.000000, -7481.000000)">
        <g id="Group-12" transform="translate(-1.000000, 7088.000000)">
          <g id="Group-6" transform="translate(733.000000, 392.000000)">
            <g
              id="icons/social/Linkedin"
              transform="translate(114.000000, 0.000000)"
            >
              <mask id="mask-linkedin-2" fill="white">
                <use xlinkHref="#path-linkedin-1"></use>
              </mask>
              <use id="Mask" fill="#212B36" xlinkHref="#path-linkedin-1"></use>
              <g id="Group" mask="url(#mask-linkedin-2)" fill="currentColor">
                <g id="Color">
                  <rect
                    id="color/background"
                    x="0"
                    y="0"
                    width="18"
                    height="18"
                    rx="4"
                  ></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const LinkedinIcon = props => <Icon component={LinkedinSvg} {...props} />

const ViberSvg = () => (
  <svg width="1.5em" height="1.5em" viewBox="0 0 24 24">
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Brand-Page-(With-Centered-Images-&amp;-Title-and-Text-Sections)"
        transform="translate(-1206.000000, -7743.000000)"
      >
        <g id="Group-17" transform="translate(-2.000000, 6912.000000)">
          <g id="Group-8" transform="translate(2.000000, 507.000000)">
            <g id="Viber" transform="translate(1206.000000, 324.000000)">
              <g id="Group-18">
                <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
              </g>
              <g
                id="Group-19"
                transform="translate(5.000000, 5.000000)"
                fill="currentColor"
                fillRule="nonzero"
              >
                <path
                  d="M9.02715624,6.55364767 C9.49442396,6.45417199 9.85261176,6.27655095 10.1585768,5.98997551 C10.5523074,5.61817099 10.7681875,5.16817279 10.8630388,4.52160935 C10.9270784,4.10004283 10.900989,3.93426903 10.7515515,3.79690055 C10.6116159,3.66901519 10.3530986,3.66427363 10.196527,3.78505771 C10.0826764,3.87032635 10.0470895,3.96031895 10.0210002,4.20424247 C9.99018404,4.52871507 9.93323892,4.75607175 9.83601984,4.96686603 C9.62726948,5.41447807 9.25962824,5.64658071 8.63819632,5.72236627 C8.34641148,5.75789927 8.25865024,5.79105051 8.16379456,5.90234711 C7.99063104,6.10839979 8.057034,6.44233351 8.29660048,6.56549495 C8.38676908,6.61048907 8.42471928,6.61523059 8.62392816,6.60338771 C8.74727624,6.59628199 8.9299372,6.57497363 9.02715624,6.55364767 L9.02715624,6.55364767 Z"
                  id="Path-path-viber"
                  transform="translate(9.481164, 5.153278) rotate(-85.000000) translate(-9.481164, -5.153278) "
                ></path>
                <path
                  d="M8.52193845,7.07247955 C9.96173137,6.86171163 11.076516,6.19382227 11.8070718,5.10912983 C12.217434,4.49809939 12.4735879,3.78049191 12.5613536,3.01078903 C12.5921697,2.72895075 12.5921697,2.21501423 12.5589902,2.12974559 C12.5281301,2.04924047 12.4285081,1.94028167 12.3431058,1.89530515 C12.2506134,1.84792927 12.0537723,1.85264887 11.9446484,1.90950779 C11.7619875,2.00186019 11.7074497,2.14871175 11.7074497,2.54658815 C11.7074497,3.15997839 11.5485148,3.80654183 11.2734055,4.30863547 C10.960302,4.88177315 10.5049039,5.35543511 9.94987497,5.68464927 C9.47310981,5.96884731 8.76864337,6.17961959 8.12584881,6.23171503 C7.89337685,6.25068119 7.76529765,6.29803947 7.67753641,6.39987495 C7.54236713,6.55382783 7.52809893,6.76224035 7.64194957,6.93511547 C7.76529325,7.12695671 7.95504429,7.15774819 8.52193845,7.07247955 L8.52193845,7.07247955 Z"
                  id="Path-path-viber"
                  transform="translate(10.074802, 4.490220) rotate(-85.000000) translate(-10.074802, -4.490220) "
                ></path>
                <path
                  d="M2.93604889,14.7236566 C3.01908337,14.6952469 3.14716257,14.6289444 3.22069965,14.5815685 C3.67133581,14.2831458 4.92610441,12.6798017 5.33646661,11.8792854 C5.57126233,11.4222079 5.64952613,11.0835326 5.57603309,10.8324858 C5.50008865,10.5624948 5.37441681,10.4203847 4.81225381,9.96802675 C4.58691589,9.78568615 4.37580221,9.59858203 4.34262273,9.54884199 C4.25722485,9.42568055 4.18841453,9.18411683 4.18841453,9.01359711 C4.19082189,8.61808047 4.44697589,7.90047303 4.78380105,7.34864371 C5.04468177,6.91997587 5.51194945,6.37055031 5.97449045,5.94896179 C6.51765857,5.45158771 6.99678709,5.11295639 7.53759185,4.84530319 C8.23256081,4.49954419 8.65715157,4.41191579 8.96788733,4.55636359 C9.04615109,4.59189659 9.12914601,4.63927247 9.15527501,4.66055887 C9.17895701,4.68188919 9.36161797,4.90452635 9.56086645,5.15080523 C9.94509965,5.63397227 10.0328609,5.71211763 10.296149,5.80211023 C10.6306108,5.91578859 10.9721626,5.88501911 11.3160779,5.70975783 C11.5770026,5.57474915 12.1462601,5.22187123 12.5139014,4.96610047 C12.9977566,4.62742519 14.0319185,3.78429211 14.1719025,3.61611463 C14.418559,3.31297235 14.46128,2.92460103 14.2952109,2.49588919 C14.1196841,2.04357515 13.436576,1.19568295 12.9598108,0.83331759 C12.5281299,0.50648519 12.2221649,0.38100355 11.8189324,0.36203735 C11.486878,0.34547055 11.3493013,0.37388023 10.9247106,0.54914151 C7.59453257,1.92041371 4.93559745,3.96663275 2.82455721,6.77788343 C1.72163345,8.24624959 0.881953733,9.76908855 0.307925493,11.3487733 C-0.0264922673,12.2700473 -0.0430841873,12.6703055 0.232025093,13.1416033 C0.350646453,13.3405327 0.855864373,13.8331608 1.22350561,14.1078758 C1.83548405,14.5626111 2.11772745,14.7307711 2.34306533,14.778125 C2.49723393,14.8112894 2.76524873,14.7852395 2.93604889,14.7236566 L2.93604889,14.7236566 Z"
                  id="Path-path-viber"
                  transform="translate(7.217335, 7.575290) rotate(-90.000000) translate(-7.217335, -7.575290) "
                ></path>
                <path
                  d="M8.35827239,7.76074867 C9.17422607,7.65891319 9.83361259,7.46234799 10.5570739,7.10946567 C11.2686304,6.76130295 11.7240329,6.43211079 12.3265139,5.83293199 C12.8910402,5.26689563 13.2041437,4.83821019 13.5361982,4.17272015 C13.9987391,3.24431843 14.2620272,2.14068183 14.3070675,0.925726629 C14.3236991,0.511283389 14.3118383,0.418891469 14.2169385,0.300493549 C14.0366849,0.0707331092 13.6405469,0.108669869 13.5053777,0.366796029 C13.4626567,0.452064669 13.4507959,0.525450909 13.4365673,0.857042389 C13.4128413,1.36623739 13.3772985,1.69542955 13.3061247,2.08858639 C13.0262447,3.63035635 12.2861915,4.86190035 11.1049599,5.74530355 C10.1206179,6.48421059 9.10304799,6.84421619 7.77005519,6.92236155 C7.31937943,6.94841147 7.24111127,6.96497391 7.13912583,7.04314123 C6.94933079,7.19235255 6.93987735,7.54285311 7.12249431,7.70626711 C7.23398155,7.80812455 7.31224535,7.82232719 7.69888591,7.81048435 C7.90050215,7.80338299 8.19697411,7.77969727 8.35827239,7.76074867 L8.35827239,7.76074867 Z"
                  id="Path-path-viber"
                  transform="translate(10.652175, 3.981300) rotate(-85.000000) translate(-10.652175, -3.981300) "
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const ViberIcon = props => <Icon component={ViberSvg} {...props} />

const YtSvg = () => (
  <svg width="1.5em" height="1.5em" viewBox="0 0 24 24">
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Brand-Page-(With-Centered-Images-&amp;-Title-and-Text-Sections)"
        transform="translate(-1162.000000, -7707.000000)"
      >
        <g id="Group-17" transform="translate(-2.000000, 6912.000000)">
          <g id="Group-8" transform="translate(2.000000, 507.000000)">
            <g id="youtube" transform="translate(1162.000000, 288.000000)">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
              <g id="Group-23" transform="translate(2.000000, 5.000000)">
                <path
                  d="M20.4334387,2.34229839 C20.1934387,1.42028224 19.4862451,0.694233848 18.5882609,0.447822587 C16.9609091,5.95079541e-13 10.4347826,5.95079541e-13 10.4347826,5.95079541e-13 C10.4347826,5.95079541e-13 3.90865611,5.95079541e-13 2.28118578,0.447822587 C1.38320159,0.694233848 0.676007935,1.42028224 0.436007935,2.34229839 C1.20792265e-13,4.01334678 1.20792265e-13,7.5 1.20792265e-13,7.5 C1.20792265e-13,7.5 1.20792265e-13,10.9865322 0.436007935,12.6577016 C0.676007935,13.5797178 1.38320159,14.3057662 2.28118578,14.5522984 C3.90865611,15 10.4347826,15 10.4347826,15 C10.4347826,15 16.9609091,15 18.5882609,14.5522984 C19.4862451,14.3057662 20.1934387,13.5797178 20.4334387,12.6577016 C20.8695652,10.9865322 20.8695652,7.5 20.8695652,7.5 C20.8695652,7.5 20.8695652,4.01334678 20.4334387,2.34229839 Z"
                  id="Combined-Shape-path-yt"
                  fill="currentColor"
                ></path>
                <polygon
                  id="Fill-2"
                  fill="#1B467F"
                  points="8.47826087 11.0869565 8.47826087 4.56521739 13.6956522 7.82621159"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const YtIcon = props => <Icon component={YtSvg} {...props} />

const TiktokSvg = () => (
  <svg width="1.1em" height="1.1em" viewBox="0 0 24 24">
    <path
      d="M7.59752158,17.5512915 C7.97849069,17.7602499 8.40278727,17.8693332 8.8334968,17.8691665 C10.2681932,17.8691665 11.4393977,16.6827915 11.4922644,15.2041665 L11.4975551,2 L14.6665928,2 C14.6668734,2.28045208 14.691964,2.56028333 14.741504,2.83596666 L12.4211396,2.83596666 L12.4211396,2.83642499 L14.741504,2.83642499 L15.5905782,2.83642499 C15.5901373,3.94151248 15.9754351,5.0092333 16.6750074,5.84132496 C16.675288,5.84167913 16.6755686,5.8420333 16.6758892,5.84238746 C17.3894898,6.32699996 18.2235737,6.58466662 19.0759746,6.58383329 L19.0759746,7.31758328 C19.3742968,7.38399995 19.6827595,7.41937495 20,7.41937495 L20,10.7146666 C18.4178058,10.7165833 16.8751715,10.2008749 15.5906182,9.24062493 L15.5906182,15.9361665 C15.5906182,19.2795415 12.9736951,22 9.75708135,22 C8.95606424,22.0002081 8.16362445,21.8284165 7.42942222,21.4953748 C6.69574105,21.1626248 6.03608933,20.6759998 5.49164219,20.0659998 C5.49124138,20.0657082 5.49084858,20.0654165 5.49044777,20.0651248 C3.98613082,18.9671665 3,17.1513749 3,15.1001665 C3,11.7562916 5.61690707,9.0354166 8.8334968,9.0354166 C9.09654785,9.03670827 9.35915802,9.05662493 9.61960381,9.09495827 L9.61960381,9.87504159 C9.61960381,9.87504159 9.61960381,9.87504159 9.61960381,9.87504159 L9.61960381,12.4585416 C9.61960381,12.4585416 9.61960381,12.4585416 9.61960381,12.4585416 L9.61960381,9.87504159 C9.63792079,9.87466659 9.65611753,9.87399993 9.67439442,9.87337493 C9.70180977,9.87237493 9.72930528,9.87137493 9.75708135,9.87137493 C10.0200923,9.87266659 10.2827426,9.89258326 10.5431483,9.93091659 L10.5431483,13.2944999 C10.2946466,13.2134166 10.0315956,13.1662082 9.75708135,13.1662082 C9.05069529,13.1670832 8.37348812,13.4592082 7.87403983,13.9784999 C7.37459153,14.4977915 7.09370447,15.2018332 7.09302309,15.9361249 C7.09306317,16.5161249 7.26937912,17.0812915 7.59684021,17.5509165 C7.59708069,17.5510415 7.59732118,17.5511665 7.59752158,17.5512915 Z M11,18 C11.5755939,17.6163644 11.9741233,16.8670705 12,16 L12,16.0003908 C11.9741233,16.8671771 11.5755939,17.6163999 11,18 Z M8.75953471,11.9764167 C8.92403488,11.9764583 9.08453368,11.993 9.24046529,12.0235833 C9.08214904,11.9927917 8.92116522,11.9769583 8.75953471,11.9764167 Z M4,18 C4.2292791,18.7467962 4.57144797,19.4242553 5,20 C4.56272445,19.4150047 4.22507009,18.7346601 4,18 Z M15,15 L15,8 C15,8 15,8 15,8 L15,15 Z"
      id="Shape"
      fill="currentColor"
    ></path>
  </svg>
)

export const TiktokIcon = props => <Icon component={TiktokSvg} {...props} />


const CalendarSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z" /></svg>
)
export const CalendarIcon = props => <Icon component={CalendarSvg} {...props} />


const ChevronRightSvg = () => (
  <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>ic_chevron_right_24px</title>
    <g id="WEB" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Home-Page:-Full" transform="translate(-238.000000, -765.000000)">
        <g id="Group-40" transform="translate(0.000000, -1.000000)">
          <g id="Group-13" transform="translate(79.000000, 766.000000)">
            <g id="Group" transform="translate(159.000000, 0.000000)">
              <polygon id="Shape" points="0 0 30 0 30 30 0 30"></polygon>
              <polygon id="Shape" fill="#ffffff" points="12.5 7.5 10.7375 9.2625 16.4625 15 10.7375 20.7375 12.5 22.5 20 15"></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)


export const ChevronRighIcon = props => <Icon component={ChevronRightSvg} {...props} />